import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdmin = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18.3 12.5q.3.125.562.275t.538.375l1.45-.5 1 1.75-1.15 1q.05.3.05.625 0 .326-.05.625l1.15 1-1 1.7-1.45-.45a4.4 4.4 0 0 1-.538.337q-.262.138-.562.263L18 21h-2l-.3-1.5a7 7 0 0 1-.562-.263 4.4 4.4 0 0 1-.538-.337l-1.45.45-1-1.7 1.15-1a5 5 0 0 1-.05-.65q0-.3.05-.65l-1.15-1 1-1.7 1.45.45q.275-.2.538-.337.262-.138.562-.263L16 11h2zm-7.95.5q.15 0 .3.05-.725 1.8-.6 3.575.124 1.774 1.2 3.375H2v-2.8q0-.824.425-1.55.425-.725 1.175-1.1 1.275-.65 2.875-1.1T10 13zM17 14q-.825 0-1.412.588A1.93 1.93 0 0 0 15 16q0 .825.588 1.412Q16.176 18 17 18q.825 0 1.412-.588Q19 16.825 19 16t-.588-1.412A1.93 1.93 0 0 0 17 14M10 4q1.65 0 2.825 1.175T14 8t-1.175 2.825Q11.65 12.001 10 12t-2.825-1.175Q6 9.65 6 8t1.175-2.825T10 4" })
});
export default SvgAdmin;
